import { render, staticRenderFns } from "./OccurrenceTypeList.vue?vue&type=template&id=c0a8fb44&"
import script from "./OccurrenceTypeList.js?vue&type=script&lang=js&"
export * from "./OccurrenceTypeList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports